const mutations = {
  'SET_REGIONS' (state, value) {
    state.regions = value
  },
  'SET_REGION' (state, value) {
    state.region = value
  }
}
export default mutations
